import {Injectable} from '@angular/core';
import {ChartData} from './doughnut.component';

@Injectable()
export class ChartDataUtil {
    public convertToChartData(portfolios: any[]): ChartData[] {
        const categorizedInvestmentsPerPortfolio = portfolios.map(portfolio => {
            const investments = portfolio.loan_details.map(loanDetail => ({
                    loan: loanDetail.loan_id,
                    amount: loanDetail.fund_allocation
                }))
                .filter(({loan}) => loan.loan_sanction_status !== 'closed')
                .map(({loan, amount}) => ({rating: loan.rating, amount}));
            return ({
                portfolioId: portfolio._id,
                categorizedInvestments: this.categorizeInvestmentsForPortfolio(investments)
            });
        });
        const overallCategorizedInvestments = categorizedInvestmentsPerPortfolio.map(v => v.categorizedInvestments)
            .reduce((acc, val) => {
                    acc.aPlusCategory += val.aPlusCategory;
                    acc.aCategory += val.aCategory;
                    acc.bCategory += val.bCategory;
                    acc.cCategory += val.cCategory;
                    return acc;
                },
                {aPlusCategory: 0, aCategory: 0, bCategory: 0, cCategory: 0});

        return this.convertCategorizedInvestmentsToChartData(overallCategorizedInvestments);
    }

    public convertToChartDataForPortfolio(portfolio: any): ChartData[] {
        const investments = portfolio.loan_details.map(loanDetail => ({
                loan: loanDetail.loan_id,
                amount: loanDetail.fund_allocation
            }))
            .filter(({loan}) => loan.loan_sanction_status !== 'closed')
            .map(({loan, amount}) => ({rating: loan.rating, amount}));
        const categorizedInvestmentsForPortfolio = this.categorizeInvestmentsForPortfolio(investments);
        return this.convertCategorizedInvestmentsToChartData(categorizedInvestmentsForPortfolio);
    }

    public convertToChartDataForInvestments(investments: { rating: string, amount: number }[]) {
        const categorizedInvestmentsForPortfolio = this.categorizeInvestmentsForPortfolio(investments);
        return this.convertCategorizedInvestmentsToChartData(categorizedInvestmentsForPortfolio);
    }

    private categorizeInvestmentsForPortfolio(investments: { rating: string, amount: number }[]): CategorizedInvestments {
        const categorizedInvestmentsPerPortfolio: CategorizedInvestments = {aPlusCategory: 0, aCategory: 0, bCategory: 0, cCategory: 0};

        investments.forEach(({rating, amount}) => {
            const loanRatingCategory = rating.substr(0, 1) !== 'A' ?
                rating.substr(0, 1) :
                rating.substr(0, 2) === 'A+' ? 'A+' : 'A';

            switch (loanRatingCategory) {
                case 'A+':
                    categorizedInvestmentsPerPortfolio.aPlusCategory += amount;
                    break;
                case 'A':
                    categorizedInvestmentsPerPortfolio.aCategory += amount;
                    break;
                case 'B' :
                    categorizedInvestmentsPerPortfolio.bCategory += amount;
                    break;
                case 'C':
                    categorizedInvestmentsPerPortfolio.cCategory += amount;
            }
        });

        return categorizedInvestmentsPerPortfolio;
    }

    private convertCategorizedInvestmentsToChartData(categorizedInvestments: CategorizedInvestments): ChartData[] {
        return <ChartData[]>[
        //     {
        //     data: categorizedInvestments.aPlusCategory,
        //     label: 'A+1-A+3',
        //     color: '#1ea226'
        // }, 
        {
            data: categorizedInvestments.aCategory,
            label: 'A1-A6',
            color: '#97b81e'
        }, {
            data: categorizedInvestments.bCategory,
            label: 'B1-B6',
            color: '#ffc80b'
        }, {
            data: categorizedInvestments.cCategory,
            label: 'C1-C6',
            color: '#f65a41'
        }];
    }
}

interface CategorizedInvestments {
    aPlusCategory: number;
    aCategory: number;
    bCategory: number;
    cCategory: number;
}